export default __webpack_public_path__ + "static/media/print.c79ed778.svg";